// extracted by mini-css-extract-plugin
module.exports = {"larChat":"ChatUserTab_larChat__1boTm","activeLARChat":"ChatUserTab_activeLARChat__1z1vW","larChatRole":"ChatUserTab_larChatRole__1UFM8"};